<!-- Footer.vue -->
<template>
  <footer class="footer">
    <div class="background">
      <div class="container">
        <!-- LEFT: 로고 + 주소/연락처 -->
        <section class="left-wrap">
          <div class="branding">
            <a href="/" class="logo-link" aria-label="ICIK 홈으로">
              <img :src="iciklogo" alt="ICIK Logo" class="logo-image" width="271" height="140" />
            </a>
          </div>

          <section class="contact-info">
            <h2 class="section-title">주소</h2>
            <address class="address">
              08506 서울시 금천구 가산디지털2로 108,
              905호(가산동, 뉴티캐슬)
            </address>
            <ul class="contact-list">
              <li>
                <a href="tel:070-4489-7447" class="contact-link" aria-label="전화 걸기">
                  TEL : 070-4489-7447
                </a>
              </li>
            </ul>
          </section>
        </section>

        <!-- RIGHT: 방문자 수 -->
        <section class="metrics" aria-labelledby="visitor-stats-title">
          <h2 id="visitor-stats-title" class="section-title">방문자 수</h2>
          <ul class="metrics-grid" role="list">
            <li class="metric">
              <span class="metric__label">오늘 방문자</span>
              <strong class="metric__value"><div>{{ state.toDayVisits }}</div></strong>
            </li>
            <!-- <li class="metric">
              <span class="metric__label">이번주</span>
              <strong class="metric__value"><data value="842">842</data></strong>
            </li>
            <li class="metric">
              <span class="metric__label">이번달</span>
              <strong class="metric__value"><data value="3912">3,912</data></strong>
            </li> -->
            <li class="metric">
              <span class="metric__label">총 방문자</span>
              <strong class="metric__value"><div>{{ state.totalVisits }}</div></strong>
            </li>
          </ul>
        </section>
      </div>
    </div>

    <!-- BOTTOM BAR -->
    <div class="bottom">
      <div class="bottom__inner">
        <p class="copyright">© 2025 ~ {{ new Date().getFullYear() }} ICIK. All rights reserved.</p>
        <nav class="legal" aria-label="푸터 링크">
          <a href="/forms/PrivacyPolicy.hwp" download="개인정보취급방침.hwp" class="legal__link">개인정보처리방침</a>
          <span aria-hidden="true" class="divider">·</span>
          <a href="/forms/TermsofService.hwp" download="이용약관(한국내부통제협회).hwp" class="legal__link">이용약관</a>
          <span aria-hidden="true" class="divider">·</span>
          <a @click="go({ path: '/qnamain', query: { tab: 'qna' } })" class="legal__link">문의하기</a>
        </nav>
      </div>
    </div>
  </footer>
</template>

<script setup>
import iciklogo from '@/assets/HeaderICIK.png'
import { useRouter } from 'vue-router'
import { increaseDailyVisitr, selectAllVisits } from '@/api/user'
import { onMounted, reactive } from 'vue'



const router = useRouter()
function go(to) { router.push(to) }

const state = reactive({
  toDayVisits: 0,
  totalVisits: 0
})

const VIEW_TTL_MS = 15 * 60 * 1000 // 15분

function shouldIncreaseView() {
  const last = Number(localStorage.getItem(getKey()) || 0)
  return Date.now() - last >= VIEW_TTL_MS
}

function markViewed() {
  localStorage.setItem(getKey(), String(Date.now()))
}


async function increaseDaily() {

  // 1) 조회수 증가 (15분 TTL)
  try {
    if (shouldIncreaseView()) {
      await increaseDailyVisitr({})
      // 낙관적 증가 (곧 상세 조회로 다시 덮어씌워짐)
      if (state.viewCount != null) state.viewCount += 1
      markViewed()
    }
  } catch (e) {
    console.warn('뷰 카운트 업데이트 실패:', e)
  }

  // 2) 상세 조회
  const result = await selectAllVisits({})
  if (result?.result === 'ok') {
    state.toDayVisits = result.data.toDayVisits
    state.totalVisits = result.data.totalVisits

  }
}

onMounted(async () => {
  increaseDaily()
})


</script>

<style scoped>
/* 폰트/문단 규격 */
.footer {
  --bg: #ffffff;
  --ink: #0f172a;
  --muted: #64748b;
  --line: #e5e7eb;
  --brand: #220e52;
  --accent: #30308a;

  background: var(--bg);
  border-top: 1px solid var(--line);
  width: 100%;
  font-family: 'Noto Sans KR', sans-serif;
}
.footer p { font-size: 0.95rem; }

/* 래핑 */
.background {
  width: 100%;
  display: grid;
  place-items: center;
  background: var(--bg);
}

/* 컨테이너: 좌/우 2열 */
.container {
  width: 100%;
  max-width: 1200px;
  /* padding: 28px 20px 14px; */
  display: grid;
  grid-template-columns: 1fr auto; /* 왼쪽 묶음 / 오른쪽 방문자 */
  gap: 24px;
  align-items: start;
}

/* LEFT 묶음 (로고 + 주소) */
.left-wrap {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 18px 24px;
  align-items: start;
  margin: 16px 10px;
}
.logo-link { display: inline-block; }
.logo-image { width: 180px; height: auto; }

.address { color: var(--ink); line-height: 1.7; margin-bottom: 8px; font-size: 0.85rem;}
.contact-list { list-style: none; padding: 0; margin: 0; }
.contact-link { color: var(--ink); text-decoration: none; transition: color .2s; font-size: 0.85rem;}
.contact-link:hover { color: var(--accent); }

/* 타이틀 규격 */
.section-title {
  font-size: 0.925rem;
  font-weight: 700;
  color: var(--brand);
  margin-bottom: 12px;
}

/* RIGHT: 방문자 */
.metrics {
  justify-self: end; /* 오른쪽 끝 정렬 */
  text-align: right;
  margin: 16px 10px;
}
.metrics-grid {
  display: grid;
  grid-template-columns: repeat(1, minmax(120px, 1fr));
  gap: 10px 12px;
  justify-items: end;
}
.metric {
  border-radius: 12px;
  padding: 4px 6px;
  display: grid;
  gap: 4px;
}
.metric__label { font-size: 0.75rem; color: var(--muted); }
.metric__value {
  font-size: 0.925rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: var(--ink);
}

/* BOTTOM BAR */
.bottom { border-top: 1px solid var(--line); background: #fafafa; }
.bottom__inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 14px 20px;
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: 12px;
}
copyright, .copyright { color: var(--muted); font-size: 0.95rem; }
.legal { display: flex; gap: 10px; align-items: center; }
.legal__link {
  font-size: 0.95rem; color: var(--muted);
  text-decoration: none; transition: color .2s;
  cursor: pointer;
}
.legal__link:hover { color: var(--accent); }
.divider { color: var(--line); }

/* 반응형 */
@media (max-width: 1024px) {
  .container {
    grid-template-columns: 1fr auto;
    padding: 16px 0;
    justify-items: center;   /* ✅ 내부 요소 중앙 정렬 */
    text-align: center;      /* ✅ 텍스트 중앙 정렬 */
  }

  .metrics {
    justify-self: center;    /* ✅ 오른쪽 정렬 → 중앙 */
    text-align: center;
  }

  .metrics-grid {
    justify-items: center;   /* ✅ 각 방문자 지표 중앙 정렬 */
  }

  .logo-image {
    width: 150px;
    margin: 0 auto;          /* ✅ 이미지 가운데 배치 */
  }
}

@media (max-width: 640px) {
  .container {
    grid-template-columns: 1fr;
    gap: 16px;
    justify-items: center;   /* ✅ 모바일에서도 중앙 유지 */
    text-align: center;
  }

  .left-wrap {
    grid-template-columns: 1fr;
    gap: 8px;
    justify-items: center;
    text-align: center;
  }

  .logo-image {
    width: 120px;
    margin: 0 auto;
  }

  .metrics-grid {
    grid-template-columns: repeat(2, 1fr);
    justify-items: center;
  }

  .bottom__inner {
    grid-template-columns: 1fr;
    text-align: center;
    justify-items: center;
    gap: 6px;
  }
}

</style>
